import { useModal } from '@panel/commons/hooks';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSavePostingState } from '../../ducks/savePosting/selectors';
import { clearSaveError } from '../../ducks/savePosting/operations';
import { GeneralError } from './generalError';
import { Modal } from './ModalWrapper';

const ModalDispatcher = React.memo(() => {
  const { postingId, loading, error, response, lastResponse } = useSelector(getSavePostingState);
  const { isShowing, toggleValue } = useModal();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading && error) {
      toggleValue(true);
    }
  }, [postingId, loading, response, lastResponse, error, isShowing, toggleValue]);

  useEffect(() => {
    if (isShowing) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isShowing]);

  const onClose = () => {
    toggleValue(false);
    dispatch(clearSaveError());
  };

  return (
    isShowing && (
      <Modal>
        <GeneralError openModal={isShowing} onClose={onClose} handleClick={onClose} />
      </Modal>
    )
  );
});

export { ModalDispatcher };
